export const PASSWORD_MIN_LENGTH = 6
export const PASSWORD_MAX_LENGTH = 128
